import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { CreateProductKit, IProductKit, ProductKitListResponse, ProductKitQueryParams, UpdateProductKit } from '@frontend/product/types';

export class ProductKitClient extends APIClient {
    public static readonly endpoint = '/product-api/v1';

    public static async fetchProductKits(queryParams?: ApiQueryParams<ProductKitQueryParams>): Promise<ProductKitListResponse> {
        return await this.apiPaginated<ProductKitListResponse, ProductKitQueryParams>(`${this.endpoint}/kits`, queryParams);
    }

    public static async resolveProductKits(ids: string[]): Promise<ProductKitListResponse> {
        const response = await this.post(`${this.endpoint}/kits-resolve`, { ids });
        return await this.handleResponse<ProductKitListResponse>(response);
    }

    public static async deleteProductKits(ids: string[]): Promise<void> {
        const response = await this.post(`${this.endpoint}/kits-delete`, { ids });
        return await this.handleVoidResponse(response);
    }

    public static async postProductKit(accountId: string, productKit: CreateProductKit): Promise<IProductKit> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/kits`, productKit);
        return await this.handleResponse<IProductKit>(response);
    }

    public static async fetchProductKit(accountId: string, id: string): Promise<IProductKit> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/kits/${id}`);
        return await this.handleResponse<IProductKit>(response);
    }

    public static async patchProductKit(accountId: string, id: string, productKit: UpdateProductKit): Promise<IProductKit> {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}/kits/${id}`, productKit);
        return await this.handleResponse<IProductKit>(response);
    }

    public static async deleteProductKit(accountId: string, id: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/kits/${id}`);
        return await this.handleVoidResponse(response);
    }
}
